import { Typography } from "antd";

const LABEL_REVIEW = "Review on DocuSign";

type Props = {
  href: string;
};

const DocusignLink = ({ href }: Props) => {
  return (
    <Typography.Link
      href={href}
      target="_blank"
    >
      {LABEL_REVIEW}
    </Typography.Link>
  );
};

export default DocusignLink;
